export default {
  table: {
    tableClass: 'table table-striped table-header-active',
    ascendingIcon: 'entypo entypo-up-dir',
    descendingIcon: 'entypo entypo-down-dir'
  },
  pagination: {
    wrapperClass: 'btn-group',
    activeClass: 'focus',
    disabledClass: 'disabled',
    pageClass: 'btn btn-primary hide-not-focused-btn',
    linkClass: 'btn btn-primary pagination-link-btn',
    icons: {
      first: 'fa fa-angle-double-left',
      prev: 'fa fa-angle-left',
      next: 'fa fa-angle-right',
      last: 'fa fa-angle-double-right'
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-components/vuestic-datatable/data/data-table-styles.js